import { HttpContextToken } from '@angular/common/http';

export const CONTRACT_SIGN_TOKEN = new HttpContextToken<string | null>(() => null);
